import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import micro from '@/sui/data/sheets/edit/micro'
import multi from '@/sui/data/sheets/edit/multi'
import clone from 'clone'

import go from '@/gojs/go'

const pneuFields = (function () {
  function build (p) {
    const ff = [
      'diagnosis', 'diagDate', 'origin', 'episod', 'microOrg', 'covidStatus'
    ]
    const result = {}
    ff.forEach(
      f => {
        result[f] = `${p}${fields[f]}`
      }
    )
    return result
  }

  return {
    std: build(''),
    pneu: build('pneu')
  }
})()

const select = {
  pneu: tools.equals(fields.pneumopathy, 1),
  pneuDiag: {
    std: tools.different(pneuFields.std.diagnosis, 5),
    pneu: tools.different(pneuFields.pneu.diagnosis, 5)
  }
}

const pneumopathy = tools.cfg.list(
  fields.pneumopathy, 'Pneumopathie', go.fields.yesNoUnknown, {
    def: 1, pop: tools.not(select.pneu)
  }
)

const pneuDiag = (function () {
  function build (t) {
    return tools.cfg.list(
      pneuFields[t].diagnosis, 'Critère diagnostique', go.fields.pneuDiag, {
        ph: 'Taper le code ou le nom...'
      }
    )
  }

  return {
    std: build('std'),
    pneu: build('pneu')
  }
})()

const diagDate = (function () {
  function build (t) {
    return tools.cfg.date(pneuFields[t].diagDate, 'du diagnostic')
  }

  return {
    std: build('std'),
    pneu: build('pneu')
  }
})()

const origin = (function () {
  function build (t) {
    return tools.cfg.list(
      pneuFields[t].origin, 'Origine', go.fields.bactOrigin
    )
  }

  return {
    std: build('std'),
    pneu: build('pneu')
  }
})()

const episod = (function () {
  function build (t) {
    return tools.cfg.date(pneuFields[t].episod, `de l'épisode`)
  }

  return {
    std: build('std'),
    pneu: build('pneu')
  }
})()

const pneuMicro = (function () {
  const v1 = tools.select(micro.v1.all, select.pneuDiag.std)
  const v2 = tools.select(micro.v2.all, select.pneuDiag.std)
  const v3 = tools.select(micro.v4.all, select.pneuDiag.std)
  const v4 = tools.select(micro.v5.all, select.pneuDiag.std)
  const v5 = tools.select(micro.v6.all, select.pneuDiag.std)
  const v6 = tools.select(micro.v6.all, select.pneuDiag.std)
  const pneu = {
    v2: tools.select(micro.v2.all, select.pneuDiag.pneu),
    v3: tools.select(micro.v4.all, select.pneuDiag.pneu),
    v4: tools.select(micro.v5.all, select.pneuDiag.pneu),
    v5: tools.select(micro.v6.all, select.pneuDiag.pneu),
    v6: tools.select(micro.v6.all, select.pneuDiag.pneu)
  }
  pneu.v2.field = pneu.v3.field = pneu.v4.field = pneu.v5.field = pneuFields.pneu.microOrg

  return {
    v1,
    v2,
    v3,
    v4,
    v5,
    v6,
    pneu
  }
})()

const covidStatus = (function () {
  const pneu = clone(multi.covidStatus.std)
  pneu.field = pneuFields.pneu.covidStatus
  return {
    std: multi.covidStatus.std,
    pneu
  }
})()

function removeExplaurID (list) {
  const result = clone(list)
  result.config.fields = result.config.fields.filter(
    l => l.field !== fields.explaurID
  )
  return result
}

const pneumopathies = (function () {
  function build (v, t, dd, o = false) {
    const fv = []
    const fv2 = []
    if (v !== 'v1') {
      fv.push(tools.opts(diagDate[t], { op: dd }))
      fv2.push(covidStatus[t])
      if (o) {
        fv.push(origin[t])
      }
    }

    const list = [
      episod[t],
      ...fv,
      pneuDiag[t],
      ...fv2,
      removeExplaurID(t === 'pneu' ? pneuMicro.pneu[v] : pneuMicro[v])
    ]

    if (t === 'pneu') {
      const result = []
      list.forEach(
        l => {
          result.push(tools.andSelect(l, multi.select.pneu))
        }
      )
      return result
    }

    const result = [pneumopathy]
    list.forEach(
      l => {
        result.push(tools.andSelect(l, select.pneu))
      }
    )
    return {
      type: 'array',
      field: fields.pneumopathies,
      config: {
        title: 'PNEUMOPATHIE N°',
        fields: result
      }
    }
  }

  return {
    v1: build('v1', 'std'),
    v2: build('v2', 'std'),
    v3: build('v3', 'std'),
    v4: build('v4', 'std', true),
    v5: build('v5', 'std', true),
    v6: build('v6', 'std', true, true),
    exp: {
      v1: build('v2', 'pneu', false, true),
      v2: build('v3', 'pneu', false, true),
      v3: build('v4', 'pneu', true, true),
      v4: build('v5', 'pneu', true, true)
    }
  }
})()

export default {
  all: pneumopathies,
  episod: episod,
  origin: origin,
  pneuFields: pneuFields,
  diagDate: diagDate,
  covidStatus: covidStatus,
  pneuDiag: pneuDiag
}
